<div class="filter-group" data-group-visibility-id="showLevelingFilters">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showLevelingFilters" (click)="filter.groupVisibility.showLevelingFilters = !filter.groupVisibility.showLevelingFilters; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Auto-Scaling Leveling Items" [activeRules]="activeRules.levelingFilters">
          These filters automatically scale the items shown based on the Area Level, to only show items that are still useful at the current Area Level.
        </span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showLevelingFilters) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showLevelingFilters">

      <div class="filter filter-property full-span" [class.disabled]="!filter.showLevelingGear">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showLevelingGear"
            (click)="toggleShowLevelingGear()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Leveling Gear" ruleId="gear-leveling-weapons-rare">
            Shows gear which is potentially useful while leveling through the campaign; optionally of the specified Weapon Class or Armour Defence Type@if (poe1) {, and optionally with auto-scaling linked sockets}. Using the <span class="icon icon-equalizer"></span> button, you can specify if and how different types of gear are shown, and how large the level difference between the Area Level and the Drop Level of the item is allowed to be.
            <br /><br />

            @if (filter.showLevelingGearNormal) {
              <span class="normal-item-color">Normal</span> gear is shown with a Drop Level of maximum <strong>{{filter.showLevelingGearNormalLevelDifference}}</strong> levels below the Area Level.
            }

            @if (filter.showLevelingGearMagic) {
              <span class="magic-item-color">Magic</span> gear is shown with a Drop Level of maximum <strong>{{filter.showLevelingGearMagicLevelDifference}}</strong> levels below the Area Level.
            }

            @if (filter.showLevelingGearRare) {
              <span class="rare-item-color">Rare</span> gear is shown with a Drop Level of maximum <strong>{{filter.showLevelingGearRareLevelDifference}}</strong> levels below the Area Level.
            }

            @if (poe2 && filter.showLevelingGearIgnoreLevelDifferenceForSpecialWeaponTypes) {
              <br /><br />All <strong>Caster Weapons</strong> (Wands, Sceptres, Staves) and <strong>Quivers</strong> will be shown regardless of Drop Level.
            }

            @if (filter.showLevelingGearAllMagicRareBoots && filter.showLevelingGearArmour) {
              <br /><br />All <span class="magic-item-color">Magic</span> and <span class="rare-item-color">Rare</span> <strong> Boots</strong> will be shown regardless of Defence Type and Drop Level until Area Level <strong>{{ filter.showLevelingGearAllMagicRareBootsMaxAreaLevel }}</strong>.
            }

            @if (poe1 && filter.showLevelingGearExcellentSocketed) {
              @if (filter.showLevelingGearExcellentSocketedDifference) {
                <br /><br />Socketed gear with the maximum number of links that can drop at the current Area Level is shown with a Drop Level of maximum <strong>{{ filter.showLevelingGearExcellentSocketedDifference }}</strong> levels below the Area Level.
              } @else {
                <br /><br />Socketed gear with the maximum number of links that can drop at the current Area Level is always shown.
              }
            }
            @if (poe1 && filter.showLevelingGearOtherSocketed) {
              @if (filter.showLevelingGearOtherSocketedLevelDifference) {
                <br /><br />Socketed gear with one less than the maximum number of links that can drop at the current Area Level is shown with a Drop Level of maximum <strong>{{ filter.showLevelingGearOtherSocketedLevelDifference }}</strong> levels below the Area Level.
              } @else {
                <br /><br />Socketed gear with one less than the maximum number of links that can drop at the current Area Level is always shown.
              }
            }

            <br /><br />When enabled, on the <a href="/tier-list/gear">Gear Tier List</a> tab you can simulate which items would be shown as <span class="normal-item-color">Normal</span>, <span class="magic-item-color">Magic</span>, <span class="rare-item-color">Rare</span>{{ poe1 ? ', with linked sockets' : '' }}, or potentially Hidden.
            <br /><br />In the first 5 areas, all <span class="rare-item-color">Rares</span> of any type are shown. @if (poe2) { Starter weapons in The Riverbank are never hidden. }
          </span>
          <span class="sep"></span>
          <button class="btn toggle-button show-filters-button" [class.active]="showLevelingGearFilters" [disabled]="!filter.showLevelingGear"
            (click)="showLevelingGearFilters = !showLevelingGearFilters">
            <span class="icon icon-equalizer"></span>
          </button>
        </span>
      </div>

      @if (showLevelingGearFilters) {
        <div class="filter filter-property filter-padded-left" style="width: 100%;">
          <span class="filter-body">
            <span class="filter-title filter-title-inline" [class.disabled]="!filter.showLevelingGear">
              <span class="filter-title-text">Between Area Levels</span>
              <div class="filter-tip">
                <p>
                  Set a starting Area Level below where you are currently at, to reduce the filter output size.
                  <br /><br />
                  Set a maximum Area Level after which no more Leveling Gear must be shown and you will switch to 'Favourite Equipment' or only 'Other Equipment' filters.
                </p>
              </div>
            </span>
            <span class="sep"></span>
            <input type="number" min="0" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
              [disabled]="!filter.showLevelingGear" [(ngModel)]="filter.showLevelingGearMinAreaLevel" (change)="updateFilter()">
            <span class="sep"></span>
            <input type="number" max="80" placeholder="max" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
              [disabled]="!filter.showLevelingGear" [(ngModel)]="filter.showLevelingGearMaxAreaLevel" (change)="updateFilter()">
            <div class="spacer" style="display: table-cell; width: 100%;"></div>
          </span>
        </div>

        @if (poe1) {
          <div class="filter filter-property filter-padded-left" style="width: 100%;">
            <span class="filter-body">
              <div class="filter-title filter-label table-checkbox-group">
                <span class="input-group-btn">
                  <button class="btn toggle-btn"
                    [class.off]="filter.showLevelingGearExcellentSocketed === false"
                    (click)="toggleShowLevelingGearExcellentSocketed()"></button>
                </span>
                <div class="table-checkbox-label">
                  <span class="filter-title-text">Excellent Linked Sockets</span>
                  <div class="filter-tip">
                    <p>
                      Leveling gear with the <strong>maximum number of linked sockets</strong> that can drop at the current Area Level (4-links from Area Level 25, 5-links from 35, 6-links from 50). Not shown before Area Level 25.
                      <br /><br />If disabled, this sort of socketed gear will not be shown, unless by other rules.
                    </p>
                  </div>

                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherGearLevelingExcellentSocketed"
                    [active]="filter.showLevelingGearExcellentSocketed"
                    exampleName="Leveling Gear"
                    [sockets]="'LWWWW'"></app-equipment-tier-picker>

                </div>
              </div>
              <span class="sep"></span>
              <div class="filter-title filter-label">
                Diff.
                <div class="filter-tip">
                  <p>
                    <app-content cid="diff-leveling" contentType="tip"></app-content>
                  </p>
                </div>
              </div>
              <span class="sep"></span>
              <input type="number" placeholder="max" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
                [disabled]="!filter.showLevelingGearExcellentSocketed"
                [(ngModel)]="filter.showLevelingGearExcellentSocketedDifference" (change)="updateFilter()">
              <div class="spacer" style="display: table-cell; width: 100%;"></div>
            </span>
          </div>

          <div class="filter filter-property filter-padded-left" style="width: 100%;">
            <span class="filter-body">
              <div class="filter-title filter-label table-checkbox-group">
                <span class="input-group-btn">
                  <button class="btn toggle-btn"
                    [class.off]="filter.showLevelingGearOtherSocketed === false"
                    (click)="toggleShowLevelingGearOtherSocketed()"></button>
                </span>
                <div class="table-checkbox-label">
                  <span class="filter-title-text">Good Linked Sockets</span>
                  <div class="filter-tip">
                    <p>
                      Leveling gear with <strong>one less than the maximum</strong> linked sockets that can drop at the current Area Level (3-links before Area Level 25, then 3/4/5-links as higher links unlock).
                      <br /><br />If disabled, this sort of socketed gear will not be shown, unless by other rules.
                    </p>
                  </div>

                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherGearLevelingGoodSocketed"
                    [active]="filter.showLevelingGearOtherSocketed"
                    exampleName="Leveling Gear"
                    [sockets]="'LWWW'"></app-equipment-tier-picker>

                </div>
              </div>
              <span class="sep"></span>
              <div class="filter-title filter-label">
                Diff.
              </div>
              <span class="sep"></span>
              <input type="number" placeholder="max" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
                [disabled]="!filter.showLevelingGearOtherSocketed"
                [(ngModel)]="filter.showLevelingGearOtherSocketedLevelDifference" (change)="updateFilter()">
              <div class="spacer" style="display: table-cell; width: 100%;"></div>
            </span>
          </div>
        }

        <div class="filter filter-property filter-padded-left" style="width: 100%;">
          <span class="filter-body">
            <div class="filter-title filter-label table-checkbox-group">
              <span class="input-group-btn">
                <button class="btn toggle-btn"
                  [class.off]="filter.showLevelingGearRare === false"
                  (click)="toggleShowLevelingGearRare()"></button>
              </span>
              <div class="table-checkbox-label">
                <span class="filter-title-text">Rare</span>
                <div class="filter-tip">
                  <p>
                    If disabled, Rare leveling gear will not be shown, unless by other rules.
                  </p>
                </div>

                @if (filter.showLevelingGearRare) {
                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherGearLevelingRare"
                    [alignLeft]="true"
                    [active]="filter.showLevelingGearRare"
                    exampleName="Leveling Gear"
                    [rarity]="Rarity.Rare"></app-equipment-tier-picker>
                }

              </div>
            </div>
            <span class="sep"></span>
            <div class="filter-title filter-label">
              Diff.
            </div>
            <span class="sep"></span>
            <input type="number" placeholder="max" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
              [disabled]="!filter.showLevelingGearRare"
              [(ngModel)]="filter.showLevelingGearRareLevelDifference" (change)="updateFilter()">
              <div class="spacer" style="display: table-cell; width: 100%;"></div>
          </span>
        </div>
        <div class="filter filter-property filter-padded-left" style="width: 100%;">
          <span class="filter-body">
            <div class="filter-title filter-label table-checkbox-group">
              <span class="input-group-btn">
                <button class="btn toggle-btn"
                  [class.off]="filter.showLevelingGearMagic === false"
                  (click)="toggleShowLevelingGearMagic()"></button>
              </span>
              <div class="table-checkbox-label">
                <span class="filter-title-text">Magic</span>
                <div class="filter-tip">
                  <p>
                    If disabled, Magic leveling gear will not be shown, unless by other rules.
                  </p>
                </div>

                @if (filter.showLevelingGearMagic) {
                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherGearLevelingMagic"
                    [alignLeft]="true"
                    [active]="filter.showLevelingGearMagic"
                    exampleName="Leveling Gear"
                    [rarity]="Rarity.Magic"></app-equipment-tier-picker>
                }

              </div>
            </div>
            <span class="sep"></span>
            <div class="filter-title filter-label">
              Diff.
            </div>
            <span class="sep"></span>
            <input type="number" placeholder="max" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
              [disabled]="!filter.showLevelingGearMagic"
              [(ngModel)]="filter.showLevelingGearMagicLevelDifference" (change)="updateFilter()">
            <div class="spacer" style="display: table-cell; width: 100%;"></div>
          </span>
        </div>
        <div class="filter filter-property filter-padded-left" style="width: 100%;">
          <span class="filter-body">
            <span class="sep"></span>
            <div class="filter-title filter-label table-checkbox-group">
              <span class="input-group-btn">
                <button class="btn toggle-btn"
                  [class.off]="filter.showLevelingGearNormal === false"
                  (click)="toggleShowLevelingGearNormal()"></button>
              </span>
              <div class="table-checkbox-label">
                <span class="filter-title-text">Normal</span>
                <div class="filter-tip">
                  <p>
                    If disabled, Normal leveling gear will not be shown, unless by other rules.
                  </p>
                </div>

                @if (filter.showLevelingGearNormal) {
                  <app-equipment-tier-picker
                    [equipmentType]="EquipmentType.OtherGearLevelingNormal"
                    [alignLeft]="true"
                    [active]="filter.showLevelingGearNormal"
                    exampleName="Leveling Gear"></app-equipment-tier-picker>
                }

              </div>
            </div>
            <span class="sep"></span>
            <div class="filter-title filter-label">
              Diff.
            </div>
            <span class="sep"></span>
            <input type="number" placeholder="max" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
              [disabled]="!filter.showLevelingGearNormal"
              [(ngModel)]="filter.showLevelingGearNormalLevelDifference" (change)="updateFilter()">
            <div class="spacer" style="display: table-cell; width: 100%;"></div>
          </span>
        </div>
        @if (poe2) {
          <div class="filter filter-property filter-padded-left" style="width: 100%;">
            <span class="filter-body">
              <span class="sep"></span>
              <div class="filter-title filter-label table-checkbox-group">
                <span class="input-group-btn">
                  <button class="btn toggle-btn"
                    [class.off]="filter.showLevelingGearIgnoreLevelDifferenceForSpecialWeaponTypes === false"
                    (click)="toggleShowLevelingGearIgnoreLevelDifferenceForSpecialWeaponTypes()"></button>
                </span>
                <div class="table-checkbox-label">
                  <span class="filter-title-text">Ignore Level Difference for Special Base Types</span>
                  <div class="filter-tip">
                    <p>
                      The Base Types of Caster Weapons (Wands, Sceptres, Staves) and Quivers don't have inherent damage or defence stats which scale with their Drop Level, so they remain relevant longer — even until endgame.
                      <br /><br />If enabled, these items will always be shown, regardless of their Drop Level.
                    </p>
                  </div>
                </div>
              </div>
            </span>
          </div>
        }
        <div class="filter filter-property filter-padded-left" style="width: 100%;" [class.disabled]="!filter.showLevelingGearAllMagicRareBoots">
            <span class="filter-body">
              <span class="sep"></span>
              <div class="filter-title filter-label table-checkbox-group">
                <span class="input-group-btn">
                  <button class="btn toggle-btn"
                    [class.off]="filter.showLevelingGearAllMagicRareBoots === false"
                    (click)="toggleShowLevelingGearAllMagicRareBoots()"></button>
                </span>
                <div class="table-checkbox-label">
                  <span class="filter-title-text">Always show Magic & Rare Boots</span>
                  <div class="filter-tip">
                    <p>
                      During League Start, Movement Speed on Boots is more important than their Defence Type and value. Be sure to always check the Armour Vendor in town for them. Additionally, this option shows <i>all</i> Magic and Rare Boots you encounter, regardless of their Defence Type and Drop Level, so you can identify them in search for Movement Speed.
                      <br /><br />Disable once you have found a good pair.
                    </p>
                  </div>

                  @if (filter.showLevelingGearAllMagicRareBoots) {
                    <app-equipment-tier-picker
                      [equipmentType]="EquipmentType.OtherGearLevelingMagicRareBoots"
                      [alignLeft]="true"
                      [active]="filter.showLevelingGearAllMagicRareBoots"
                      exampleName="Magic & Rare Boots"></app-equipment-tier-picker>
                  }
                </div>
              </div>
              <span class="sep"></span>
              <div class="filter-title filter-label" [class.disabled]="!filter.showLevelingGearAllMagicRareBoots">
                Until{{ isMobile() ? '' : ' Area Level' }}
              </div>
              <span class="sep"></span>
              <input type="number" placeholder="max" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
                [disabled]="!filter.showLevelingGearAllMagicRareBoots"
                [(ngModel)]="filter.showLevelingGearAllMagicRareBootsMaxAreaLevel" (change)="updateFilter()">
              <div class="spacer" style="display: table-cell; width: 100%;"></div>
            </span>
          </div>
      }

      <div class="filter filter-property full-span" [class.disabled]="!filter.showLevelingGearWeapons">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showLevelingGearWeapons"
            (click)="toggleShowLevelingGearWeapons()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Leveling Weapons" ruleId="gear-leveling-weapons-rare">
            @if (poe2) {
              Starter weapons in The Riverbank are never hidden.
            }
          </span>
          <span class="sep"></span>
          <app-autocomplete style="width: 215px"
            [options]="weaponClasses"
            [disabled]="!filter.showLevelingGearWeapons"
            [showOptions]="true"
            [selectedValues]="filter.showLevelingGearWeaponClasses"
            (selectedValuesChange)="levelingGearWeaponClassesChanged($event)"
          ></app-autocomplete>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showLevelingGearArmour">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showLevelingGearArmour"
            (click)="toggleShowLevelingGearArmour()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Leveling Armour" ruleId="gear-leveling-armour-rare">
          </span>
          <span class="sep"></span>
          <app-autocomplete style="width: 215px"
            [options]="defenceTypes"
            [disabled]="!filter.showLevelingGearArmour"
            [showOptions]="true"
            [selectedValues]="filter.showLevelingGearArmourDefenceTypes"
            (selectedValuesChange)="levelingGearArmourDefenceTypesChanged($event)"
          ></app-autocomplete>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showLevelingFlasks">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showLevelingFlasks" (click)="toggleShowLevelingFlasks()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Leveling Flasks" ruleId="flasks-leveling-life-mana">
            <app-content cid="leveling-flasks" contentType="tip" [conditions]="{ poe1: poe1, poe2: poe2 }"></app-content>
          </span>
          @if (poe1) {
            <span class="sep"></span>
            <div class="filter-title filter-label table-checkbox-group">
              <span class="input-group-btn">
                <button class="btn toggle-btn" [class.off]="filter.showLevelingFlasksAlwaysHideHybrid === false" (click)="toggleShowLevelingFlasksAlwaysHideHybrid()"></button>
              </span>
              <div class="table-checkbox-label">
                <span class="filter-title-text">Hide Hybrid Flasks</span>
              </div>
            </div>
          }
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showLevelingGold">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showLevelingGold" (click)="toggleShowLevelingGold()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Leveling Gold" ruleId="gold-leveling">
            <span [innerHTML]="levelingGoldTooltip"></span>
          </span>
        </span>
      </div>

      @if (poe2) {
        <div class="filter filter-property full-span" [class.disabled]="!filter.showLevelingVerisium">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showLevelingVerisium" (click)="toggleShowLevelingVerisium()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Leveling Verisium" ruleId="verisium-leveling">
              <span [innerHTML]="levelingVerisiumTooltip"></span>
            </span>
          </span>
        </div>
      }

    </div>
    <div class="clear"></div>
  }
</div>

